import React from "react"
import axios from 'axios'
import PropTypes from 'prop-types';
import { Upload, message, notification, Space } from "antd"
import { InboxOutlined, CloseCircleOutlined } from "@ant-design/icons"

const DragUpload = props => {
  const config = {
    data: props.data,
    name: props.name,
    multiple: props.multiple,
    maxCount: props.multiple ? undefined : 1,
    disabled: props.disabled,
    accept: props.accept,
    beforeUpload: props.beforeUpload,
    onChange(info) {
      const { name, status, error, response } = info.file

      if (status === "done") {
        if (props.showSuccessMessage) message.success(`${name} file uploaded successfully.`)
        if (typeof props.onUploadSuccess === 'function') {
          props.onUploadSuccess(response);
        }
      } else if (status === "error") {
        if (typeof props.onUploadError === 'function') {
          props.onUploadError(error);
          return false;
        }
        notification.open({
          message: 'Error',
          description: error.response?.data.message || error.message,
          duration: 0,
          icon: <CloseCircleOutlined style={{ color: 'red' }} />,
          style: { width: 500 }
        });
      }

      return false;
    },
    async customRequest(options) {
      const { onSuccess, onError, file } = options;

      const formData = new FormData();
      formData.append("file", file);

      if (props.data) {
        Object.entries(props.data).forEach(([key, value]) => {
          formData.append(key, value);
        });
      }

      try {
        const res = await axios({
          method: props.method,
          url: props.action,
          data: formData,
          timeout:  2 * 60 * 1000,
          headers: { "content-type": "multipart/form-data" }
        })
        onSuccess(res);
      } catch (err) {
        onError(err)
      }
    }
  };

  return (
    <div className="upload">
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <Upload.Dragger {...config}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          {props.additionalDesc && <p>({props.additionalDesc})</p>}
        </Upload.Dragger>
      </Space>
    </div>
  )
}

DragUpload.defaultProps = {
  name: "file",
  accept: ".xls, .xlsx, .csv",
  method: "post",
  multiple: true,
  showSuccessMessage: true,
};

DragUpload.propTypes = {
  action: PropTypes.string.isRequired,
  name: PropTypes.string,
  accept: PropTypes.string,
  additionalDesc: PropTypes.string,
  multiple: PropTypes.bool,
  showSuccessMessage: PropTypes.bool,
  method: PropTypes.oneOf(['post', 'put', 'patch']),
  data: PropTypes.object,
  beforeUpload: PropTypes.func,
  onUploadSuccess: PropTypes.func,
  onUploadError: PropTypes.func,
  disabled: PropTypes.bool,
}

export default DragUpload